enum ApplicationStatus {
  INITIAL = 'INITIAL',
  CREDIT_APPROVED = 'CREDIT_APPROVED',
  VERIFICATION = 'EXTRA_VERIFICATION',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  DEPRECATED = 'DEPRECATED',
  LOCKED = 'LOCKED',
  CONSUMER_ALERT = 'CONSUMER_ALERT',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  CREDIT_LINE_DATA_PROVIDED = 'CREDIT_LINE_DATA_PROVIDED',
}

export default ApplicationStatus;
